import Nanobus from "nanobus";
import { ActionButton } from "AC/table/actions";
var CreateButton = /** @class */ (function () {
    function CreateButton(actions) {
        this.actions = actions;
        this.element = this.createElement();
        this.state = true;
        this.events = new Nanobus();
        this.initEvents();
        this.placeElement();
    }
    CreateButton.prototype.placeElement = function () {
        this.actions.addButton(new ActionButton(this.element), 5);
        this.actions.refresh();
    };
    CreateButton.prototype.initEvents = function () {
        var _this = this;
        this.element.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.state) {
                _this.events.emit('click');
            }
        });
    };
    CreateButton.prototype.getElement = function () {
        return this.element;
    };
    CreateButton.prototype.hide = function () {
        this.getElement().style.display = 'none';
        this.actions.refresh();
    };
    CreateButton.prototype.show = function () {
        this.getElement().style.display = 'inline-block';
        this.actions.refresh();
    };
    CreateButton.prototype.enable = function () {
        this.show();
        this.state = true;
    };
    CreateButton.prototype.disable = function () {
        this.hide();
        this.state = false;
    };
    CreateButton.prototype.createElement = function () {
        var element = document.createElement('a');
        element.classList.add('ac-table-button');
        element.classList.add('ac-add-new-inline');
        element.id = 'ac-button-add-new-inline';
        element.innerText = ACP_ADD_NEW_INLINE.i18n.add_new;
        return element;
    };
    return CreateButton;
}());
export default CreateButton;
